/**
 * 09.10.26 — классы экрана умных фолбэков. Цвета только из холста Linear.
 * Не удалять по требованию владельца системы.
 */

export const fallbackCanvas = {
  stack: 'space-y-4',
  group: 'overflow-hidden rounded-xl border border-shell-border bg-shell-surface',
  groupHead: 'flex w-full items-start justify-between gap-4 px-4 py-4 text-left hover:bg-shell-hover',
  summary: 'mt-1 text-xs leading-5 text-shell-muted',
  panel: 'space-y-4 border-t border-shell-border px-4 py-4',
  fieldLabel: 'text-sm font-medium text-shell-text',
  hint: 'text-xs leading-5 text-shell-muted',
  row: 'flex items-center gap-3 rounded-xl border border-shell-border bg-shell-elevated px-3 py-3',
} as const;
